<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="secondary" flat card dense>
        <v-toolbar-title class="white--text">
          {{ $t(activeSection) }}
        </v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-form
      ref="form"
      v-model="valid"
      md-6
      v-on:submit.prevent="
        () => {
          return false;
        }
      "
      offset-3
      v-if="validParams"
    >
      <v-card-text>
        <v-text-field
          :label="$t('global.placeholder.new.password')"
          v-model="password"
          name="password"
          :rules="passwordRules"
          :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
          @click:append="() => (hidePassword = !hidePassword)"
          :type="hidePassword ? 'text' : 'password'"
          required
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions class="justify-end pb-3">
        <v-btn href="/" round flat color="primary" class="capitalize">
          {{ $t('global.action.back') }}
        </v-btn>
        <v-btn
          :disabled="!valid"
          :loading="isLoading"
          outline
          color="accent"
          class="capitalize white--text"
          @click="submit"
          round
        >
          {{ $t('global.button.send') }}
        </v-btn>
      </v-card-actions>
    </v-form>

    <advice v-else color="warning" icon="priority_high">
      {{ $t('reset.error.no.params') }}
    </advice>
  </v-card>
</template>

<script>
import Advice from '@/components/commons/Advice';
import authService from '@/services/authService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

export default {
  name: 'ResetPassword',
  components: {
    [Advice.name]: Advice
  },
  computed: {
    activeSection() {
      return store.state.activeSection;
    },
    passwordRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => v.length >= 4 || this.$i18n.t('global.validation.minimum.4'),
        v => v.length <= 50 || this.$i18n.t('global.validation.maximum.50')
      ];
    },
    api() {
      if (typeof this.$route.query.api === 'undefined') {
        return store.state.countrySelected.isoAlpha3;
      }
      return this.$route.query.api;
    },
    token() {
      return this.$route.query.token;
    },
    username() {
      return this.$route.query.username;
    }
  },
  data() {
    return {
      password: '',
      isLoading: false,
      valid: false,
      hidePassword: false,
      validParams: false
    };
  },
  created() {
    if (!this.username || !this.api || !this.token) {
      this.validParams = false;
    } else {
      this.validParams = true;
    }
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      let tokenApiLocation = _.find(store.state.countries, apiLocation => {
        return apiLocation.isoAlpha3 === this.api;
      });

      let params = {
        newPassword: this.password,
        username: this.username,
        token: this.token,
        lang: store.state.langSelected.langWsp
      };

      this.isLoading = true;

      let results = await authService.resetPassword(
        tokenApiLocation.api,
        params,
        this.resetPasswordSuccess,
        this.resetPasswordError
      );

      if (results.error) {
        this.isLoading = false;
        let status = results.status;

        if (status === 401) {
          this.isLoading = false;
          EventBus.$emit(keys.eventOnShowNotification, {
            message: this.$i18n.t('login.error.401'),
            type: 'error',
            doNotTranslate: true
          });
          return;
        } else if (status === 412) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: this.$i18n.t('reset.error.412'),
            type: 'warning',
            doNotTranslate: true
          });

          this.$router.push({ name: 'ForgotPassword' });
          return;
        }

        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('reset.toast.success'),
        type: 'success',
        doNotTranslate: true
      });

      params = {
        username: this.username,
        password: this.password
      };

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('reset.toast.logging.in'),
        type: 'success',
        doNotTranslate: true
      });

      await authService.login(params);
      this.$router.push({ path: this.$i18n.t('urlUser') });

      this.isLoading = false;
    }
  }
};
</script>
